module.exports = __webpack_public_path__ + "static/media/squareImg.8c90848d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/squareImg.png
// module id = 105
// module chunks = 0